import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import EventInfo from '../EventInfo';
import PriceDetails from '../PriceDetails';
import formatFloatWithSuperscript from '../../../core/utils/helpers';
import { selectCartCurrency, selectCartTotal } from '../../selectors';

const Order = ({ children, open }) => {
    const total = useSelector(selectCartTotal);
    const currency = useSelector(selectCartCurrency);
    return (
        <>
            <Accordion defaultActiveKey={open ? '0' : null}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <span className="d-block w-100">
                            <span className="d-block h4 mb-3"><FormattedMessage id="cart_your_order"/></span>
                            <EventInfo/>
                            <span className="event-price-mini">
                                <span className="event-price-mini__1">
                                    <strong className="text-capitalize">Total</strong>
                                </span>
                                <span className="event-price-mini__2">
                                    <strong>{formatFloatWithSuperscript(total)}</strong> <strong>{currency}</strong>
                                </span>
                            </span>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <span className="event-price-detailed-title"><FormattedMessage id="cart_price_details"/></span>
                        <PriceDetails showTotal={true}>{children}</PriceDetails>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};
export default Order;
